module.exports = __webpack_public_path__ + "static/img/buy_all_active.884dc82e.png";